module.exports = __webpack_public_path__ + "img/data.fe541fc0.png";